import React, { ComponentType } from 'react';
import styled from 'styled-components';
import { COLORS, SPACING } from '../../style';

interface MVVItemProps {
  title: string;
  description: string;
  Icon: ComponentType;
}

const ItemContainer = styled.div`
  background: ${COLORS.white};
  border-style: solid;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: ${SPACING.md};
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(15, 61, 76, 0.08);
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${COLORS.blue} 0%, ${COLORS.green} 100%);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(15, 61, 76, 0.15);
    border-color: ${COLORS.green};

    &::before {
      transform: scaleX(1);
    }

    .icon-wrapper {
      transform: scale(1.1);
      background: ${COLORS.blue};

      svg {
        color: ${COLORS.white};
      }
    }
  }

  .icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(75, 166, 156, 0.15) 0%, rgba(15, 61, 76, 0.15) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: ${SPACING.sm};
    transition: all 0.3s ease;

    svg {
      font-size: 28px;
      color: ${COLORS.blue};
      transition: all 0.3s ease;
    }
  }

  h4 {
    color: ${COLORS.blue};
    font-size: 22px;
    font-weight: 700;
    margin-bottom: ${SPACING.sm};
    display: flex;
    align-items: center;
  }

  p {
    font-size: 16px;
    color: ${COLORS.grey};
    line-height: 1.6;
    margin: 0;
  }
`;

const MVVItem = ({ title, description, Icon }: MVVItemProps) => {
  return (
    <ItemContainer>
      <div className="icon-wrapper">
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </ItemContainer>
  );
};

export default MVVItem;
